// Date utility functions for consistent DD-MM-YYYY formatting

/**
 * Formats a date object or string to DD-MM-YYYY format
 * @param {Date|string} date - Date to format
 * @returns {string} - Formatted date string in DD-MM-YYYY format
 */
export const formatDateToDDMMYYYY = (date) => {
  if (!date) return '';
  
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  
  return `${day}-${month}-${year}`;
};

/**
 * Converts DD-MM-YYYY format to YYYY-MM-DD format (for input fields)
 * @param {string} dateString - Date string in DD-MM-YYYY format
 * @returns {string} - Date string in YYYY-MM-DD format
 */
export const convertDDMMYYYYToYYYYMMDD = (dateString) => {
  if (!dateString) return '';
  
  const parts = dateString.split('-');
  if (parts.length !== 3) return '';
  
  const [day, month, year] = parts;
  return `${year}-${month}-${day}`;
};

/**
 * Converts YYYY-MM-DD format to DD-MM-YYYY format
 * @param {string} dateString - Date string in YYYY-MM-DD format
 * @returns {string} - Date string in DD-MM-YYYY format
 */
export const convertYYYYMMDDToDDMMYYYY = (dateString) => {
  if (!dateString) return '';
  
  const parts = dateString.split('-');
  if (parts.length !== 3) return '';
  
  const [year, month, day] = parts;
  return `${day}-${month}-${year}`;
};

/**
 * Gets today's date in DD-MM-YYYY format
 * @returns {string} - Today's date in DD-MM-YYYY format
 */
export const getTodayDDMMYYYY = () => {
  return formatDateToDDMMYYYY(new Date());
};

/**
 * Gets today's date in YYYY-MM-DD format (for input fields)
 * @returns {string} - Today's date in YYYY-MM-DD format
 */
export const getTodayYYYYMMDD = () => {
  const d = new Date();
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  
  return `${year}-${month}-${day}`;
};

